module.exports = __webpack_public_path__ + "img/formMs.d6400e9b.svg";